<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="10">
        <base-material-card color="primary">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{
                id
                  ? $i18n.t("Edit paygateway - ") + paygateway.name
                  : $i18n.t("Create paygateway")
              }}
            </div>
          </template>
          <v-form id="form" v-model="isValid">
            <v-card>
              <v-card-text>
                {{ $i18n.t("Payment Gateway Details") }}
              </v-card-text>

              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      :label="$i18n.t('Title')"
                      :rules="validationrules.title"
                      required
                      v-model="paygateway.title"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <z-entity-select
                      class="purple-input"
                      v-model="paygateway.entity_id"
                      corp="self"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-select
                      :items="gateway"
                      :label="$i18n.t('Gateway Type')"
                      v-model="paygateway.pgKind"
                      solo
                      :rules="validationrules.kind"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox
                      v-model="paygateway.active"
                      :label="$i18n.t('Is Active')"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card>
              <v-row>
                <v-col cols="12" md="10">
                  <v-card-text>
                    {{ $i18n.t("Payment Gateway Options") }}
                  </v-card-text>
                </v-col>
                <v-col style="margin-top: 10px">
                  <v-btn
                    x-small
                    fab
                    text
                    class="float-right"
                    color="blue"
                    @click="add()"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-card-text>
                <v-row v-for="gateway in paygateway.types" :key="gateway.title">
                  <v-col cols="12" md="2">
                    <v-text-field
                      :label="$i18n.t('Title')"
                      v-model="gateway.title"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select
                      :items="paygateway.paymentTypeOptions"
                      :label="$i18n.t('Configration')"
                      v-model="gateway.type"
                      solo
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      :label="$i18n.t('Charge Name')"
                      v-model="gateway.name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      :label="$i18n.t('Amount')"
                      v-model="gateway.amount"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="2" lg="2">
                    <toggle-button
                      v-model="gateway.isAbs"
                      :labels="{ checked: '/-', unchecked: '%' }"
                      lg
                      :height="30"
                      :width="70"
                      :font-size="20"
                    />
                  </v-col>
                  <v-col cols="12" md="2" class="justify-content-end">
                    <v-btn x-small fab text @click="remove()" color="red">
                      <v-icon>mdi-minus-circle-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card>
              <v-row>
                <v-col cols="12" md="10">
                  <v-card-text>
                    {{ paygateway.pgKind + $i18n.t(" Detail") }}
                  </v-card-text>
                </v-col>
              </v-row>
              <v-card-text>
                <!-- gateway paytm -->
                <v-row class="ml-2">
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYTM'">
                    <v-text-field
                      :label="$i18n.t('MID') + '*'"
                      v-model="paygateway.paytmDeed.mid"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYTM'">
                    <v-text-field
                      :label="$i18n.t('Key') + '*'"
                      v-model="paygateway.paytmDeed.key"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYTM'">
                    <v-text-field
                      :label="$i18n.t('Website') + '*'"
                      v-model="paygateway.paytmDeed.website"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYTM'">
                    <v-text-field
                      :label="$i18n.t('Channel Id') + '*'"
                      v-model="paygateway.paytmDeed.channel_id"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYTM'">
                    <v-text-field
                      :label="$i18n.t('Industry Type') + '*'"
                      v-model="paygateway.paytmDeed.industryType"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYTM'">
                    <v-text-field
                      :label="$i18n.t('URL') + '*'"
                      v-model="paygateway.paytmDeed.url"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYTM'">
                    <v-text-field
                      :label="$i18n.t('Confirm URL')"
                      v-model="paygateway.paytmDeed.confirmUrl"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYTM'">
                    <v-text-field
                      :label="$i18n.t('Refund Url')"
                      v-model="paygateway.paytmDeed.refundUrl"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYTM'">
                    <z-currency-select
                      class="purple-input"
                      v-model="paygateway.currencies"
                      :label="$i18n.t('Currency')"
                      multiple
                    />
                  </v-col>
                </v-row>
                <!-- gateway paytm End-->

                <!-- payU gateway -->
                <v-row>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYU'">
                    <v-text-field
                      :label="$i18n.t('Key') + '*'"
                      v-model="paygateway.payuDeed.key"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYU'">
                    <v-text-field
                      :label="$i18n.t('Salt') + '*'"
                      v-model="paygateway.payuDeed.salt"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYU'">
                    <v-text-field
                      :label="$i18n.t('Auth Header') + '*'"
                      v-model="paygateway.payuDeed.authHeader"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYU'">
                    <v-text-field
                      :label="$i18n.t('Service Provider') + '*'"
                      v-model="paygateway.payuDeed.service_provider"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="10" v-if="paygateway.pgKind == 'PAYU'">
                    <v-text-field
                      :label="$i18n.t('Payment Url') + '*'"
                      v-model="paygateway.payuDeed.url"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="10" v-if="paygateway.pgKind == 'PAYU'">
                    <v-text-field
                      :label="$i18n.t('Retrive Transaction Status Url') + '*'"
                      v-model="paygateway.payuDeed.transStatusUrl"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="10" v-if="paygateway.pgKind == 'PAYU'">
                    <v-text-field
                      :label="$i18n.t('Refund Url') + '*'"
                      v-model="paygateway.payuDeed.refundUrl"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="10" v-if="paygateway.pgKind == 'PAYU'">
                    <v-text-field
                      :label="$i18n.t('Success Url') + '*'"
                      v-model="paygateway.payuDeed.surl"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="10" v-if="paygateway.pgKind == 'PAYU'">
                    <v-text-field
                      :label="$i18n.t('Failure  Url') + '*'"
                      v-model="paygateway.payuDeed.furl"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="10" v-if="paygateway.pgKind == 'PAYU'">
                    <v-text-field
                      :label="$i18n.t('Callback  Url')"
                      v-model="paygateway.payuDeed.curl"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" v-if="paygateway.pgKind == 'PAYU'">
                    <z-currency-select
                      class="purple-input"
                      v-model="paygateway.paytmDeed.currency"
                      :label="$i18n.t('Currency')"
                      multiple
                    />
                  </v-col>
                </v-row>
                <!-- payU gateway End-->

                <!-- gateway paypal -->
                <v-row class="ml-2" v-if="paygateway.pgKind == 'PAYPAL'">
                  <v-col cols="12" md="5">
                    <v-text-field
                      :label="$i18n.t('Key') + '*'"
                      v-model="paygateway.payPalDeed.key"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      :label="$i18n.t('Secret') + '*'"
                      v-model="paygateway.payPalDeed.secret"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      :label="$i18n.t('Url') + '*'"
                      v-model="paygateway.payPalDeed.url"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      :label="$i18n.t('Url') + '*'"
                      v-model="paygateway.payPalDeed.intent"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                      :items="paypalIntent"
                      :label="$i18n.t('Kind')"
                      v-model="paygateway.payPalDeed.intent"
                      solo
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="5">
                    <z-currency-select
                      class="purple-input"
                      v-model="paygateway.currencies"
                      :label="$i18n.t('Currency')"
                      multiple
                    />
                  </v-col>
                </v-row>
                <!-- gateway paypal End-->

                <!-- gateway razorpay -->
                <v-row class="ml-2" v-if="paygateway.pgKind == 'RAZORPAY'">
                  <v-col cols="12" md="5">
                    <v-text-field
                      :label="$i18n.t('Key') + '*'"
                      v-model="paygateway.razorPayDeed.key"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      :label="$i18n.t('Secret') + '*'"
                      v-model="paygateway.razorPayDeed.secret"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      :label="$i18n.t('Url') + '*'"
                      v-model="paygateway.razorPayDeed.url"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <z-currency-select
                      class="purple-input"
                      v-model="paygateway.currencies"
                      :label="$i18n.t('Currency')"
                      multiple
                    />
                  </v-col>
                </v-row>
                <!-- gateway razorpay End-->

                <!-- gateway payubiz -->
                <v-row class="ml-2" v-if="paygateway.pgKind == 'PAYUBIZ'">
                  <v-col cols="12" md="5">
                    <v-text-field
                      :label="$i18n.t('Key') + '*'"
                      v-model="paygateway.payuBizDeed.key"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      :label="$i18n.t('Salt') + '*'"
                      v-model="paygateway.payuBizDeed.salt"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      :label="$i18n.t('Url') + '*'"
                      v-model="paygateway.payuBizDeed.url"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <z-currency-select
                      class="purple-input"
                      v-model="paygateway.currencies"
                      :label="$i18n.t('Currency')"
                      multiple
                    />
                  </v-col>
                </v-row>
                <!-- gateway payubiz End-->
              </v-card-text>
            </v-card>

            <!-- bank detail  -->
            <v-card>
              <v-row>
                <v-col cols="12" md="10">
                  <v-card-text>{{ $i18n.t("Bank Details") }}</v-card-text>
                </v-col>
              </v-row>
              <!-- bank detail End -->
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      :label="$i18n.t('Bank')"
                      v-model="paygateway.bankAccount.bank"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      :label="$i18n.t('Bank Account')"
                      v-model="paygateway.bankAccount.accountNo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      :label="$i18n.t('IFSC Code')"
                      v-model="paygateway.bankAccount.ifsc"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      :label="$i18n.t('Holder Name')"
                      v-model="paygateway.bankAccount.holderName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      :label="$i18n.t('Account Type')"
                      v-model="paygateway.bankAccount.accountType"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      :label="$i18n.t('Branch Name')"
                      v-model="paygateway.bankAccount.branchName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      :label="$i18n.t('Bank Name')"
                      v-model="paygateway.bankAccount.bankName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      :label="$i18n.t('Swift Code')"
                      v-model="paygateway.bankAccount.swiftCode"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      :label="$i18n.t('Acqirer Acc Code')"
                      v-model="paygateway.bankAccount.acquirerAccCode"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <z-currency-select
                      class="purple-input"
                      v-model="paygateway.bankAccount.currency"
                      :label="$i18n.t('Currency')"
                    />
                  </v-col> </v-row
              ></v-card-text>
            </v-card>

            <v-row style="padding: 0 20px">
              <v-btn small fab :to="'/settings/paymentGateway'">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                :disabled="!isValid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-row>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  isValid = true;
  id = null;
  paygateway = {
    title: "",
    pgKind: "PAYTM",
    types: [],
    bankAccount: {},
    paytmDeed: {},
    payuDeed: {},
    payPalDeed: {},
    razorPayDeed: {},
    payuBizDeed: {},
  };
  paypalIntent = ["CAPTURE", "AUTHORIZE"];
  gateway = [];
  validationrules = {
    title: [(v) => !!v || this.$i18n.t("Title is required")],
    bu: [(v) => !!v || this.$i18n.t("Entity is required")],
    kind: [(v) => !!v || this.$i18n.t("Payment Kind required")],
  };
  id = "";

  get loading() {
    return common.loading;
  }
  remove(_index) {
    this.paygateway.types.splice(_index, 1);
  }
  add() {
    if (this.paygateway.types == null) {
      this.paygateway.types = [];
    }

    this.paygateway.types.push({
      isDefault: false,
    });
  }

  async save() {
    try {
      common.setLoading(true);
      const response = await doPost(
        "/api/paymentGateway/save",
        this.paygateway
      );
      if (!this.id)
        this.$router.push("/settings/paymentGateway/" + response._id);
      this.get(response._id);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      const res = await doGet("/api/paymentGateway/" + id + "/detail");
      this.paygateway = res;
      this.id = this.paygateway._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async fetchPGKinds() {
    try {
      const res = await doGet("/api/payment/pgkind/list");
      this.gateway = res;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
    this.fetchPGKinds();
  }
}
</script>

<style scoped>
.tbody {
  height: 30px;
}
.tbody tr td {
  padding: 0 2px !important;
  cursor: pointer;
}

.tbody tr td .v-input--checkbox {
  padding: 0;
  height: 30px;
  margin-top: 8px;
}

.isActive,
.isActive:hover {
  background-color: #b2dfdb !important;
}
.bill-left-headers {
  text-transform: none;
  top: 16px;
  left: 10px;
  font-size: 12px;
}
.bill-right-headers {
  text-transform: none;
  top: 20px;
  right: 0px;
  font-size: 12px;
}
.image-download {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: #42a5f5;
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.image-remove {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: red;
  top: 4px;
  right: -12px;
  font-size: 12px;
}
.table-border {
  border: 1px #dbdbdb solid;
  padding: 10px;
}
</style>
